import styled from 'styled-components/macro';
import { GridWrapper } from '@yme/atoms/grid';
import { colorCoreGray700, colorCoreWhite1000, HERO_SECTION_BACKGROUND_SECOND, } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { commonTextShadow, HeadingLevel1, HeadingLevel4 } from '@yme/tokens/typography';
import { getTextStyles, transformSrcSetToCss } from '@yme/utils/styles';
export const ImageContainerStyled = styled(FlexWrapper) `
  position: relative;
  width: 100%;
  background-color: ${colorCoreGray700};

  min-height: 625px;

  ${ADAPTIVE.minWidth.tablet} {
    min-height: 432px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    min-height: 810px;
    max-width: 1920px;
    margin: 0 auto;
  }
`;
export const BackgroundImageStyled = styled(FlexWrapper) `
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  overflow-wrap: break-word;

  ${({ backgroundImage }) => transformSrcSetToCss(backgroundImage.srcSet, backgroundImage.src, HERO_SECTION_BACKGROUND_SECOND)}

  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
export const GridWrapperStyled = styled(GridWrapper) `
  margin-top: auto;
  padding: 96px 0;
`;
export const ContentWrapperStyled = styled.div `
  max-width: 660px;
`;
export const SubTitleStyled = styled(HeadingLevel4) `
  margin-bottom: 4px;
  ${commonTextShadow}
`;
export const TitleStyled = styled(HeadingLevel1) `
  margin-bottom: 16px;
  ${commonTextShadow}
`;
export const DescriptionStyled = styled.div `
  & > p,
  & > * {
    ${getTextStyles('Ubuntu', 400, 14, 20)}

    color: ${colorCoreWhite1000};

    word-break: break-word;

    ${ADAPTIVE.minWidth.desktop} {
      ${getTextStyles('Ubuntu', 400, 16, 24)}
    }
  }

  ul {
    margin: 0;
    padding-inline-start: 28px;
  }
`;
